import { splitMarkdownLinks } from '~shared/markdown-link';

/**
 * Текст сообщения о выигрыше (add-prize-win-messages): абзацы по переводу строки, markdown-ссылки `http(s)` —
 * ссылками в новой вкладке, остальное — текстом React, без интерпретации HTML.
 */
export function MessageText({ text, className }: { text: string; className?: string }) {
  return (
    <div className={className}>
      {text.split('\n').map((line, i) => (
        <p key={i}>
          {splitMarkdownLinks(line).map((part, j) =>
            part.href ? (
              <a key={j} href={part.href} target="_blank" rel="noopener noreferrer">
                {part.text}
              </a>
            ) : (
              <span key={j}>{part.text}</span>
            ),
          )}
        </p>
      ))}
    </div>
  );
}
